module.exports = __webpack_public_path__ + "img/peijian.5ffcc1fd.png";